/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { CombinedVisitorAdapter } from '../../combined/visitors/CombinedVisitorAdapter';
import { NodeCompat } from '../../compat/NodeCompat';
import { Operation } from '../models/common/Operation';

/**
 * Constructor.
 * @param {string} operationId
 * @class
 * @extends CombinedVisitorAdapter
 * @author eric.wittmann@gmail.com
 */
export class OperationFinder extends CombinedVisitorAdapter {
    /*private*/ operationId : string;

    public found : Operation;

    public constructor(operationId? : any) {
        if(((typeof operationId === 'string') || operationId === null)) {
            let __args = arguments;
            super();
            if(this.operationId===undefined) this.operationId = null;
            if(this.found===undefined) this.found = null;
            if(this.operationId===undefined) this.operationId = null;
            if(this.found===undefined) this.found = null;
            (() => {
                this.operationId = operationId;
            })();
        } else if(operationId === undefined) {
            let __args = arguments;
            super();
            if(this.operationId===undefined) this.operationId = null;
            if(this.found===undefined) this.found = null;
            if(this.operationId===undefined) this.operationId = null;
            if(this.found===undefined) this.found = null;
            (() => {
                this.operationId = null;
            })();
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.VisitorAdapter#visitOperation(io.apicurio.datamodels.core.models.common.Operation)
     * @param {Operation} node
     */
    public visitOperation(node : Operation) {
        if(this.operationId == null || NodeCompat.equals(this.operationId, node.operationId)) {
            if(this.found == null) {
                this.found = node;
            }
        }
    }

    /**
     * Returns true if an operation was found.
     * @return {boolean}
     */
    public isFound() : boolean {
        return this.found != null;
    }
}
OperationFinder["__class"] = "io.apicurio.datamodels.core.visitors.OperationFinder";
OperationFinder["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.asyncapi.v2.visitors.IAai20Visitor","io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor","io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor","io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor","io.apicurio.datamodels.openapi.visitors.IOasVisitor"];




